class ReadMoreLines extends HTMLElement {
  constructor() {
    super();

    this.content = this.querySelector('.clamp');
    this.button = this.querySelector('button');
    this.resizeObserver = null;

    this.textMore = this.button.getAttribute('data-more') || 'Read more';
    this.textLess = this.button.getAttribute('data-less') || 'Read less';

    // Set CSS variable from "lines" attribute
    const lines = this.getAttribute('lines') || 3;
    this.content.style.setProperty('--lines', lines);

    this.toggle = this.toggle.bind(this);
  }

  connectedCallback() {
    if (!this.content || !this.button) return;

    this.button.addEventListener('click', this.toggle);

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateVisibility());
      this.resizeObserver.observe(this.content);
    }

    this.updateVisibility();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.toggle);
    this.resizeObserver?.disconnect();
    this.resizeObserver = null;
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';

    // Toggle class only
    this.content.classList.toggle('is-expanded', !expanded);

    // Update button text
    this.button.textContent = expanded ? this.textMore : this.textLess;

    // Update aria-expanded
    this.button.setAttribute('aria-expanded', String(!expanded));

    // Re-evaluate visibility after the layout change.
    this.updateVisibility();
  }

  updateVisibility() {
    if (!this.content || !this.button) return;

    const needsReadMore = this.needsReadMore();

    this.button.classList.toggle('hidden', !needsReadMore);

    if (!needsReadMore) {
      this.content.classList.remove('is-expanded');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.textContent = this.textMore;
      return;
    }

    const expanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.textContent = expanded ? this.textLess : this.textMore;
  }

  needsReadMore() {
    const clone = this.content.cloneNode(true);
    clone.classList.remove('is-expanded');
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.height = 'auto';
    clone.style.maxHeight = 'none';
    clone.style.WebkitLineClamp = '';
    clone.style.width = `${this.content.getBoundingClientRect().width}px`;

    this.content.parentNode.appendChild(clone);

    const needsReadMore = clone.scrollHeight > clone.clientHeight + 1;

    clone.remove();

    return needsReadMore;
  }
}

customElements.define('read-more-lines', ReadMoreLines);
